import { render, staticRenderFns } from "./logisticsDesgin.vue?vue&type=template&id=151a58dd&scoped=true&"
import script from "./logisticsDesgin.vue?vue&type=script&lang=js&"
export * from "./logisticsDesgin.vue?vue&type=script&lang=js&"
import style0 from "./logisticsDesgin.vue?vue&type=style&index=0&id=151a58dd&scoped=true&lang=css&"
import style1 from "./logisticsDesgin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151a58dd",
  null
  
)

export default component.exports